module.exports = __webpack_public_path__ + "static/cups-ba582ea7e46f41548b5b4c8878523a27.png";